export class WifiInfo {
  count: string = "";
  lastWifi: string = "";

  constructor(lastWifi:string, count: string) {
    this.count = count
    this.lastWifi = lastWifi
  }

  public static factory() {
    return new WifiInfo("-", "-")
  }
}
